import * as fm from 'generated/api/fm.api';

type GetPdfFile = fm.paths['/open-api/download/{uuid}'];
export type GetPdfFileParams = GetPdfFile['get']['parameters']['path']['uuid'];
export type GetPdfFileRes = GetPdfFile['get']['responses']['200']['schema'];
